<template>
  <div class="container-fluid">
    <TheHeader :stationName="viewName" />
    <div class="ps-4 pe-4 pt-3">
      <GlassLoaderForm
        :glassType="glassType"
        :table-url="tableUrl"
      ></GlassLoaderForm>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import TheHeader from "@/components/layouts/TheHeader.vue";
import GlassLoaderForm from "@/components/glassloader/GlassLoaderForm.vue";

const glassType = "backglass";
const tableUrl = `/Material/GetLastMaterilglassByStationId?stationId=19&num=15`;
const viewName = "Glass Loader 2 Rückglas";

onMounted(() => {
  document.title = viewName;
});
</script>
